import { ChevronLeft } from 'lucide-react'
import React, { useState, useEffect, useMemo } from 'react'
import Pagination from '@mui/material/Pagination'
import Stack from '@mui/material/Stack'
import {
    getMappedcampagions, downloadMappedcamapgins,
    getListUnmappedCampaigns, getAllAggregatorsNamesList, getAllPartnerNamesListbyAggregatorNames, SavecampgaingsMappingData
} from '../actioncreatormarketing'
import Loader from '../../../presentationals/Loader/Loader.component'
import Popup from '../../../presentationals/Popup/Popup.component'

export default function CampaginsDash({ handleBack }) {
    const [tabs, setTabs] = useState("mapped")
    const [loader, setLoader] = useState(false)
    const [saveHandler, setSaveHandler] = useState(null);
    const [mapDisabled, setMapDisabled] = useState(true)

    const handleSave = async (fn) => {
        if (!fn) return;
        setLoader(true);
        try {
            await fn();
        } catch (err) {
            console.log(err);
        }
        setLoader(false);
    };
    return (
        <>
            {loader ? <Loader /> : ""}
            <div className='OverView-Main-Section min-size-marketing-1800'>
                <div className="HeadingFilter-Section">
                    <div>
                        <h4
                            onClick={(e) => handleBack(e)}
                            style={{
                                margin: 0,
                                display: "flex",
                                gap: "5px",
                                alignItems: "center",
                                whiteSpace: "nowrap",
                                cursor: "pointer",
                            }}
                        >
                            {" "}
                            <ChevronLeft />
                            Campaigns
                        </h4>
                    </div>
                    <div className="topsTabs" style={{ border: "none" }}>
                        <div className="rightTabs" style={{ padding: "0" }}>
                            <button
                                onClick={() => setTabs("mapped")}
                                className={`rightSideBtn ${tabs == "mapped" ? "active" : ""}`}

                            >
                                Mapped
                            </button>
                            <button
                                onClick={() => setTabs("unmapped")}
                                className={`rightSideBtn ${tabs == "unmapped" ? "active" : ""}`}

                            >
                                Unmapped
                            </button>
                        </div>
                    </div>
                </div>
                {
                    tabs == "unmapped" ?
                        <div className='HeadingFilter-Section' style={{justifyContent:'end',margin:"10px 0"}}>
                            <div className='topsTabs' style={{ border: 'none' }}>
                                <div className='rightTabs' style={{ padding: '0' }}>
                                    <button className={`rightSideBtn active`} disabled={mapDisabled} style={{ background: '#035865', color: '#fff', cursor: mapDisabled ? "no-drop" : "pointer", opacity: mapDisabled ? "0.2" : "1" }} onClick={() => saveHandler && handleSave(saveHandler)}>Map</button>
                                </div>
                            </div>
                        </div>
                        : ""}

                {
                    tabs == "mapped" ? <MappedCampaigns setLoader={setLoader} /> : ""
                }
                {
                    tabs == "unmapped" ? <UnMappedCampaigns
                        setMapDisabled={setMapDisabled}
                        setLoader={setLoader}
                        setSaveHandler={setSaveHandler}
                    /> : ""
                }
            </div>
        </>
    )
}


const MappedCampaigns = ({ setLoader }) => {
    const [campaignUnmapped, setcampaignUnmapped] = useState([])
    const [page, setPage] = useState(1)
    const rowsPerPage = 10;

    useEffect(() => {
        List()
    }, [])

    const List = () => {
        setLoader(true)
        getMappedcampagions(callback => {
            setLoader(false)
            setcampaignUnmapped(callback ?? [])
        })
    }

    const download = () => {
        setLoader(true)
        downloadMappedcamapgins(callback => {
            setLoader(false)
        })
    }

    const handleChange = (event, value) => {
        setPage(value)
    }

    const startIndex = (page - 1) * rowsPerPage
    const paginatedData = campaignUnmapped.slice(
        startIndex,
        startIndex + rowsPerPage
    )

    const pageCount = Math.ceil(campaignUnmapped.length / rowsPerPage)
    return (
        <>
            <div className="row">
                <div className="col-xs-12">
                    <div className="customDash-table" style={{ marginTop: '40px' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: "center" }}>
                            <h5>Mapped Campaigns</h5>
                            <div className='HeadingFilter-Section'>

                                <div className='topsTabs' style={{ border: 'none' }}>
                                    <div className='rightTabs' style={{ padding: '0' }}>
                                        <button className={`rightSideBtn active`} style={{ background: '#035865', color: '#fff', cursor: "pointer", margin: '0 10px 0 0' }} onClick={() => download()}>Export</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='main-customized-table'>
                            <table className='table'>
                                <thead>
                                    <tr>

                                        <th>Campaign Name</th>
                                        <th>Aggregator Name</th>
                                        <th>Partner Name</th>


                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        paginatedData?.length > 0 ? paginatedData?.map((val, id) => {

                                            return (
                                                <tr key={id}>

                                                    <td>{val?.campaignName ?? ""}</td>
                                                    <td>{val?.aggregatorName ?? ""}</td>
                                                    <td>{val?.partnerName ?? ""}</td>

                                                </tr>
                                            )
                                        })
                                            : ""}



                                </tbody>
                            </table>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'end', margin: '20px 0' }}>
                            <Stack spacing={2}>
                                <Pagination
                                    count={pageCount}
                                    page={page}
                                    onChange={handleChange}
                                    color="primary"
                                />
                            </Stack>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )

}
const UnMappedCampaigns = ({ setLoader, setSaveHandler, setMapDisabled }) => {
    const getUniqueKey = (val) => `${val.campaignId}-${val.partnerName}`
    const [popup, setPopup] = useState({ show: false, popupStatus: "" })
    const [campaignSelected, setcampaignSelected] = useState([])
    const [campaignUnmapped, setcampaignUnmapped] = useState([])
    const [ListData, setListData] = useState({ aggregatorList: [], partner: [] })
    const [assignPopup, setAssignPopup] = useState(false)
    const [search, setsearch] = useState("")
    const [objectData, setObjectData] = useState({
        companyName: "",
        partnerName: "",
    })

    useEffect(() => {
        getListUnmappedCampaignsfn()
        getAggregatorNamesListApi()
    }, [])

    // ================= API CALLS =================

    const getAggregatorNamesListApi = () => {
        setLoader(true)
        getAllAggregatorsNamesList(callback => {
            setLoader(false)
            setListData({ aggregatorList: callback?.data ?? [], partner: [] })
        })
    }

    const getAllPartnerNamesListbyAggregatorNamesApi = (val) => {
        setLoader(true)
        getAllPartnerNamesListbyAggregatorNames(val, callback => {
            setLoader(false)
            setListData((prev) => ({
                ...prev,
                partner: callback?.data ?? []
            }))
        })
    }

    const getListUnmappedCampaignsfn = () => {
        setLoader(true)
        getListUnmappedCampaigns(callback => {
            setLoader(false)
            setcampaignUnmapped(callback ?? [])
        })
    }

    // ================= SEARCH FILTER =================

    const filteredCampaigns = useMemo(() => {
        return campaignUnmapped.filter((item) =>
            item?.campaignName?.toLowerCase().includes(search.toLowerCase())
        )
    }, [campaignUnmapped, search])

    // ================= CHECKBOX HANDLING =================

    const handleSelectBox = (e, val) => {
        const key = getUniqueKey(val)
        if (e.target.checked) {
            setcampaignSelected(prev => [...prev, { key, campaignId: val.campaignId }])  // ← always store object
        } else {
            setcampaignSelected(prev => prev.filter(item => item.key !== key))
        }
    }

    const handleSelectAllBox = (e) => {
        if (e.target.checked) {
            const all = filteredCampaigns.map(val => ({ key: getUniqueKey(val), campaignId: val.campaignId }))
            setcampaignSelected(all)
        } else {
            setcampaignSelected([])
        }
    }

    // ================= DROPDOWN HANDLING =================

    const handleChange = (e, type) => {
        setObjectData((prev) => ({
            ...prev,
            [type]: e.target.value
        }))

        if (type === "companyName") {
            const ar = ListData?.aggregatorList?.filter(
                (el) => el.aggregatorId == e.target.value
            )
            getAllPartnerNamesListbyAggregatorNamesApi(ar?.[0]?.companyName ?? "")
        }
    }

    // ================= SAVE HANDLING =================

    useEffect(() => {
        setMapDisabled(campaignSelected.length === 0)
    }, [campaignSelected])

    useEffect(() => {
        setSaveHandler(() => saveRegistration)
    }, [campaignSelected])

    const saveRegistration = async () => {
        setAssignPopup(true)
    }

    const handlesaveRegistration = async () => {

        const payload = campaignSelected.map(({ campaignId }) => ({
            campaignId,
            aggregatorId: objectData.companyName,
            partnerId: objectData.partnerName,
        }))

        setLoader(true)

        SavecampgaingsMappingData(payload, callback => {

            setLoader(false)

            if (callback === 'success') {
                setPopup({ show: true, popupStatus: "Data Save Successfully !" })
            } else {
                setPopup({ show: true, popupStatus: "Please try again later !" })
            }

            setMapDisabled(true)
            setAssignPopup(false)
            setcampaignSelected([])
            getListUnmappedCampaignsfn()
            removePopup()
        })
    }

    const closePopup = () => {
        setPopup({ show: false, popupStatus: "" })
    }

    const removePopup = () => {
        setTimeout(() => {
            closePopup()
        }, 5000)
    }

    const handeclosePopup = () => {
        setAssignPopup(false)
        setcampaignSelected([])
        setObjectData({
            companyName: "",
            partnerName: "",
        })
    }
    return (
        <>
            {popup?.show && (
                <Popup closePopup={closePopup} popupStatus={popup?.popupStatus} />
            )}

            <div className="row">
                <div className="col-xs-12">

                    {/* SEARCH */}
                    <div className="HeadingFilter-main-filters">
                        <div className="row">
                            <div className="col-xl-3 col-lg-10 col-xs-12" style={{ marginTop: "5px" }}>
                                <div className='customInputSearch-bar'>
                                    <i className='fa fa-search'></i>
                                    <input
                                        placeholder='Search Campaign Name'
                                        className='customInput'
                                        value={search}
                                        onChange={(e) => setsearch(e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* TABLE */}
                    <div className="customDash-table" style={{ marginTop: '40px' }}>
                        <h5>Unmapped Campaigns</h5>

                        <div className='main-customized-table'>
                            <table className='table'>
                                <thead>
                                    <tr>
                                        <th>
                                            <input
                                                type='checkbox'
                                                onChange={handleSelectAllBox}
                                                checked={
                                                    filteredCampaigns.length > 0 &&
                                                    filteredCampaigns.every(item =>                                          // ← match by composite key
                                                        campaignSelected.some(s => s.key === getUniqueKey(item))
                                                    )
                                                }
                                            />
                                        </th>
                                        <th>Campaign Name</th>
                                        <th>Partner Name</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {filteredCampaigns.length > 0 ? (
                                        filteredCampaigns.map((val) => {
                                            const uniqueKey = getUniqueKey(val)
                                            return (
                                                <tr key={uniqueKey}>
                                                    <td>
                                                        <input
                                                            type='checkbox'
                                                            onChange={(e) =>
                                                                handleSelectBox(e, val)
                                                            }
                                                            checked={campaignSelected?.some(item => item?.key === uniqueKey)}
                                                        />
                                                    </td>
                                                    <td>{val?.campaignName ?? ""}</td>
                                                    <td>{val?.partnerName ?? ""}</td>
                                                </tr>
                                            )
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan="3" style={{ textAlign: "center" }}>
                                                No matching campaigns
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            {
                assignPopup ?
                    <div className="background-blur">

                        <div className="popup-main small-popup container-fluid max-width-500px dbl-border " style={{ padding: '20px', borderRadius: '10px' }}>
                            <i onClick={() => handeclosePopup()} style={{ float: "right", marginTop: '-18px', marginRight: '-17px', fontSize: '20px', color: 'red' }} className="fa fa-times-circle"></i>

                            <div className="row from-group">
                                <div className="col-sm-6 col-xs-12">
                                    <div className='customInput-box'>
                                        <label htmlFor="" className="label-new">Aggregator</label>
                                        <select className='customInput-new' type="text" value={objectData?.companyName} onChange={(e) => handleChange(e, "companyName")} >
                                            <option value={""}>Select Option</option>
                                            {
                                                ListData?.aggregatorList?.length > 0 ? ListData?.aggregatorList?.map((Val, id) => {
                                                    return (
                                                        <option value={Val?.aggregatorId}>{Val?.companyName}</option>
                                                    )
                                                })
                                                    : ""}

                                        </select>
                                    </div>
                                </div>
                                <div className="col-sm-6 col-xs-12">
                                    <div className='customInput-box'>
                                        <label htmlFor="" className="label-new">Partner</label>
                                        <select className='customInput-new' type="text" value={objectData?.partnerName} onChange={(e) => handleChange(e, "partnerName")} >
                                            <option value={""}>Select Option</option>
                                            {
                                                ListData?.partner?.length > 0 ? ListData?.partner?.map((Val, id) => {
                                                    return (
                                                        <option value={Val?.partnerId}>{Val?.partnerName}</option>
                                                    )
                                                })
                                                    : ""}

                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="row from-group text-center">
                                <div className="col-xs-12">
                                    <button className="btn btn-primary" style={{ marginTop: '10px', borderRadius: '5px', border: '1px solid #D3D9E9', boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)', background: '#2B78FF' }} onClick={() => handlesaveRegistration()}>Assign</button>                         </div>

                            </div>
                        </div>
                    </div>
                    : ""}


        </>
    )
}